import * as React from "react";
import Title5 from "../../global/Title5/Title5";
import Title4 from "../../global/Title4/Title4";
import {
  container,
  title,
  tileTitle,
  tileValue,
  tileLabel,
  pointsTile,
  redeemButton,
  overlaySpinner,
} from "./ProfileRewards.module.scss";
import { Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import { getMemberPoints } from "../../../services/redemption";
import { Spinner } from "react-bootstrap";
import { setMemberPointsTally } from "../../../redux/slices/Member/member";
import { useAppDispatch } from "../../../hooks";

export const Container: React.FC<any> = (props) => {
  return (
    <div className={`${container} rounded text-center`}>{props.children}</div>
  );
};

export const Greetings: React.FC<any> = (props) => {
  return (
    <div className={`${title} mb-4 text-center text-lg-start`}>
      <Title5 className={`px-3 pt-2 styledProfileTitle mb-2`}>
        {props.children}
      </Title5>
    </div>
  );
};

export const PointsTile: React.FC<{
  rewardPoints: number;
  memberId: string;
}> = (props) => {
  const [memberPoints, setMemberPoints] = React.useState();
  const [loader, setLoader] = React.useState(true);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    try {
      const getPoints = async (memberId: string) => {
        const response = await getMemberPoints(memberId);
        if (
          response?.memberPointsData &&
          response?.memberPointsData?.available
        ) {
          dispatch(setMemberPointsTally(response?.memberPointsData?.available));
          const _points = new Intl.NumberFormat("en-US").format(
            response?.memberPointsData?.available
          );
          setMemberPoints(_points);
          setLoader(false);
        } else {
          setMemberPoints(0);
          setLoader(false);
        }
      };
      getPoints(props.memberId);
    } catch (error) {
      setMemberPoints(0);
      setLoader(false);
    }
  }, []);
  return (
    <Col className={`my-auto ms-1 me-3 bg-light ${pointsTile}`}>
      <div className={tileTitle}>Points</div>
      {loader ? (
        <div className={overlaySpinner}>
          <Spinner animation="border" />
        </div>
      ) : (
        <Title4 className={`mb-1 ${tileValue}`}>{memberPoints}</Title4>
      )}
      <p className={tileLabel}>Available Points</p>
    </Col>
  );
};
export const StatusTile: React.FC<{ profileType: string }> = (props) => {
  return (
    <Col className={`my-auto ms-1 me-1 bg-light ${pointsTile}`}>
      <div className={tileTitle}>Status</div>
      <Title4 className={`mb-1 ${tileValue}`}>{props.profileType}</Title4>
      {/* <p className={tileLabel}>Available Points</p> */}
      {/* <PerksDetails perks={perks}/> */}
    </Col>
  );
};
export const RedeemPonts: React.FC = () => {
  return (
    <Col className="mx-3 ms-1 me-1 py-4 bg-light">
      <Title5 className={`center ${title}`}>
        Redeem points for free nights!
      </Title5>
      <Button variant="dark" size="lg" className={redeemButton}>
        <a href="tel:1-855-622-2160"> Call 1-855.622.2160 </a>
      </Button>
    </Col>
  );
};
